import viewRecord from '../components/viewPage.vue'
import selectedBox from '../components/selectedBox1.vue'
import store from '@/store'
export default {
  className: 'profit',
  perPage: 30,
  mixin: {
    fields: [
      // 销售经理
      {
        name: 'userId',
        note: '销售人员',
        search: {
          component: selectedBox
        }
      },
      {
        name: 'userCompany',
        note: '所属公司'
      },
      {
        // 包装
        name: 'packid'
      },

      {
        // 托盘
        name: 'palletid'
      },
      {
        name: 'finishProductid',
        width: 80,
      },
      {
        // 售价
        name: 'sellingPrice',
        width: 80,
      },
      {
        name: 'amount'
      },
      {
        name: 'costPrice',
        width: 80,
      },
      {
        // 型号利润
        name: 'idProfit',
      },
      {
        // 客户提成
        name: 'TCH',
      },
      {
        // 税率
        name: 'taxRate',
      },
      {
        // 税额
        name: 'tax',
      },
      // {
      //   // 时间
      //   name: 'days'
      // },

      {
        // 运费
        name: 'shipping',
      },

      {
        // 订单工资P
        name: 'orderSalaryP',
        note: '工资P',
      },
      {
        // 订单工资T
        name: 'orderSalaryT',
        note: '工资T',
      },
      {
        // 利润P
        name: 'profitP',
      },
      {
        // 利润T
        name: 'profitT',
      },
      {
        // 实际利润
        name: 'realProfit',
      },

      {
        name: 'profitR',
        width: 120,
      },
      'updatedAt'
    ],
    search: [
      'userId',
      'userCompany',
      'updatedAt'
    ],
    action: {
      create: false,
      edit: false,
      delete: false,
      view: store.state.user && store.state.user.authority.profit.view ? {
        type: 'row',
        text: '查看',
        component: viewRecord
      } : false
    },
    hooks: {
      beforeFetch ({ where }) {
        console.log('where', where)
        if (where.userId && where.userId !== 'null') {
          where.userId = {
            $in: where.userId
          }
        } else {
          delete where.userId
        }
      }
    }
  }
}
